// extracted by mini-css-extract-plugin
export default {"header":"header_header__DgoRj","wrapper":"header_wrapper__kjAUK","hoverText":"header_hoverText__pexq7","hoverTextBlue":"header_hoverTextBlue__mlFOD"};